<template>
  <div>
    <CCard>
      <CCardHeader>
        Edit {{ typeTitle }} Application Checklist Item
      </CCardHeader>
      <CCardBody>
        <CForm
          novalidate
          @submit.prevent
        >
          <CInput
            id="name"
            v-model="$v.form.name.$model"
            label="Name"
            horizontal
            placeholder="Checklist Name"
            :is-valid="checkIfValid(['form', 'name'])"
            :invalid-feedback="cannotBeBlank('Name')"
          />

          <CInput
            id="description"
            v-model="$v.form.description.$model"
            label="Description"
            horizontal
            placeholder="Description"
            :is-valid="checkIfValid(['form', 'description'])"
            :invalid-feedback="cannotBeBlank('Description')"
          />

          <div class="form-group form-row">
            <CCol
              :md="{ offset: '3', size: '9' }"
              :sm="{ offset: '3', size: '9' }"
            >
              <CInputCheckbox
                label="Show to Client"
                :checked.sync="form.isClientVisible"
                horizontal
              />
            </CCol>
          </div>

          <div class="form-group form-row">
            <CCol
              :md="{ offset: '3', size: '9' }"
              :sm="{ offset: '3', size: '9' }"
            >
              <CInputCheckbox
                label="Client Document Upload"
                :checked.sync="form.isDocumentUpload"
                :disabled="!form.isClientVisible"
                horizontal
              >
                <template #description>
                  <small class="text-muted">
                    Check if client needs to upload documents for this item
                  </small>
                </template>
              </CInputCheckbox>
            </CCol>
          </div>

          <CInput
            v-if="form.isClientVisible"
            id="clientDescription"
            v-model="$v.form.clientDescription.$model"
            label="Client Description"
            horizontal
            placeholder="Description shown to clients"
            :is-valid="checkIfValid(['form', 'clientDescription'])"
            :invalid-feedback="cannotBeBlank('Client Description')"
          />

          <div class="form-row">
            <CCol
              :md="{ offset: '3', size: '9' }"
              :sm="{ offset: '3', size: '9' }"
            >
              <ButtonLoading
                type="submit"
                size="sm"
                color="primary"
                :loading="isLoading"
                @click="onFormSubmit"
              >
                Update
              </ButtonLoading>
            </CCol>
          </div>
        </CForm>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { required, requiredIf  } from 'vuelidate/lib/validators'

import formGenericMixin from '@/mixins/form-generic-mixin'
import { showSuccessMessage } from '@/notification-utils'
import {capitlizeFirstLetter} from '@/utils'

export default {
  name: 'RegistrationChecklistItemEdit',

  mixins: [formGenericMixin],

  validations() {
    return {
      form: {
        name: {
          required
        },

        description: {
          required
        },

        clientDescription: {
          requiredIf: requiredIf(() => {
            return this.form.isClientVisible
          }),
        },
      }
    }
  },

  data() {
    return {
      form: {
        name: '',
        description: '',
        isClientVisible: false,
        clientDescription: '',
        isDocumentUpload: false
      },

      isLoading: false,

      type: 'seller'
    }
  },

  computed: {
    ...mapState('registrationChecklistItem', [
      'sellerRegistrationChecklistItemsConfig',
      'buyerRegistrationChecklistItemsConfig'
    ]),

    typeTitle() {
      return capitlizeFirstLetter(this.type)
    }
  },

  watch: {
    '$route.params.type': {
      immediate: true,
      async handler() {
        this.type = this.$route.params.type.toLowerCase()
        document.title = `${this.typeTitle} Application Checklist Item`
      }
    },

    'form.isClientVisible'(value) {
      if (!value) {
        this.form.isDocumentUpload = false
      }
    }
  },

  async created () {
    this.checkListId = this.$route.params.id

    let checklistItem = this.getChecklistConfig()

    if (!checklistItem) {
      await this.getRegistrationChecklistItemsConfig(this.type)
    }

    checklistItem = this.getChecklistConfig()

    this.form = {
      name: checklistItem.name,
      description: checklistItem.description,
      clientDescription: checklistItem.clientDescription,
      isClientVisible: checklistItem.clientVisible,
      isDocumentUpload: checklistItem.clientDocumentUpload
    }
  },

  methods: {
    ...mapActions('registrationChecklistItem', [
      'updateRegistrationChecklistItemsConfig',
      'getRegistrationChecklistItemsConfig'
    ]),

    async onFormSubmit() {
      try {
        this.isLoading = true

        const { isDocumentUpload, isClientVisible, ...formData } = this.form

        await this.updateRegistrationChecklistItemsConfig({
          ...formData,
          id: this.checkListId,
          type: this.type,
          clientVisible: isClientVisible,
          clientDocumentUpload: isDocumentUpload
        })

        showSuccessMessage(`Successfully updated checklist item`)

        this.routeToListPage()
      } catch {
        //
      } finally {
        this.isLoading = false
      }
    },

    routeToListPage() {
      this.$router.push({ 
        name: 'RegistrationChecklistItems', 
        params: {
          type: this.type.toLowerCase()
        } 
      })
    },

    getChecklistConfig() {
      let configItems = []

      if (this.type === 'buyer') {
        configItems = this.buyerRegistrationChecklistItemsConfig  
      } else {
        configItems = this.sellerRegistrationChecklistItemsConfig
      }

      return configItems.find(item => item.id === this.checkListId)
    }
  },
}
</script>
<style lang="scss" scoped>
  
</style>